const debounce = (fn, delay) => {
  delay = delay || 200
  let timer
  return function () {
    let th = this
    let args = arguments
    if (timer) {
      // console.log('clearTImout')
      clearTimeout(timer)
    }
    timer = setTimeout(function () {
      // console.log('setTImeOUt')
      timer = null
      fn.apply(th, args)
    }, delay)
  }
}

export default debounce



// WEBPACK FOOTER //
// ./src/utils/debounce.js